/*
 * Copyright (c) 2020. Sonrai Analytics Limited
 * Developed by Warren Dowey
 */

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventListenerService {

  private lastEventTime: number;

  constructor() { }

  eventUsed(eventTime: number): boolean {
    if (this.lastEventTime >= eventTime) {
      return true;
    } else {
      this.lastEventTime = eventTime;
      return false;
    }
  }

  useEvent(eventTime: number): void {
    if (this.lastEventTime < eventTime) {
      this.lastEventTime = eventTime;
    }
  }
}
